import React from 'react';

import { Box, Tag, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { TextBlock } from '@bcp-nextgen-dx-component-factory/design-system';

import { SimulationCardHeaderProps } from './simulationCardHeader';

export const SimulationCardHeaderBcp: React.FC<SimulationCardHeaderProps> = (props: SimulationCardHeaderProps) => {
	const { term, value, label } = props;

	return (
		<Box
			styles={{
				flexDirection: 'column',
				padding: '16px 59px',
				borderRadius: '8px',
				background: '#F5F8F9',
				alignItems: 'center',
				marginBottom: '16px',
			}}
		>
			<Box styles={{ justifyContent: 'space-evenly', width: '100%' }}>
				{/* <Tag mode="rounded" size="medium" appearance="neutralLight" label={`${term}X`} /> */}
				<TextBlock.Currency size="medium" fontWeight="strong" currency={'€/mês'} floatValue={value} />
			</Box>
			{label && (
				<Typography colorToken="primary-light" appearance="body-100-01">
					{label}
				</Typography>
			)}
		</Box>
	);
};
